var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "44px",
    viewBox: "0 0 32 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#003AFF",
    points: "0.00098 44 0.00098 0 32.00098 0 32.00098 44 16.50098 44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0011,3.5463 L0,19.5472 C0,21.4532 0,22.5218 0,24.4279 L16.0009,40.4288 L32.002,24.4278 C32.002,22.5218 32.002,21.4532 32.002,19.5472 L16.0011,3.5463 Z",
    id: "Fill-6",
    fill: "#FF0064"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-102",
    fill: "#00FFC2",
    points: "9.27557 30.87065 16.00097 24.14525 22.72637 30.87065 22.72637 36.16265 16.00097 29.43725 9.27557 36.16265"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-104",
    fill: "#00FFC2",
    points: "9.27557 22.12571 16.00097 15.40031 22.72637 22.12571 22.72637 27.41771 16.00097 20.69231 9.27557 27.41771"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-106",
    fill: "#00FFC2",
    points: "9.27557 13.38077 16.00097 6.65537 22.72637 13.38077 22.72637 18.67277 16.00097 11.94737 9.27557 18.67277"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg08);
export default __webpack_public_path__ + "static/media/08.52bbd2b47faeb20af9c885ec62ae556b.svg";
export { ForwardRef as ReactComponent };